import { render, staticRenderFns } from "./DenyRequest.vue?vue&type=template&id=34f39f79&scoped=true"
import script from "./DenyRequest.vue?vue&type=script&lang=ts"
export * from "./DenyRequest.vue?vue&type=script&lang=ts"
import style0 from "./DenyRequest.vue?vue&type=style&index=0&id=34f39f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f39f79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
